export default "__VITE_ASSET__D7E544nz__";